import React, { forwardRef,useImperativeHandle,useRef,useEffect } from "react";
import ComponentTagSelector from "../tags/ComponentTagSelector";
// import { useColonies } from "../../context/ColoniesContext.jsx";

import { useMasterData } from "../../context/MasterDataContext.jsx";
// import { searchForWorkspaceRoot } from "vite";


const Comp_Colonies = forwardRef(({
    maxTags = undefined,
    // style='',
    style={},
    tagStyle={},
    inputStyle={},

    // defaultTags = [],
    onColonySelect,
    onColonyRemove,
    onColonyChangeTag,
    onColonyNotFound,
    selectedTags = [],
    setSelectedTags = () => {},
    parentKey = 'defaultColony', // ✅ Add this line
    displayKey='name', // ✅ DEFAULT HERE
    searchKey='name'

}, ref) => {
    // console.log("📥 Comp_Colonies received defaultTags:", defaultTags);

  // console.log("selectedTags: Colonies: ", selectedTags);


    const placeHolder = "Select Colony";
    const {colonies:masterColonies,coloniesReady:coloniesReady} = useMasterData();




    const tagrefColony = useRef(null);
    const hasInitialized = useRef(false);

/**
     * Resolve colony IDs or mixed tags into full colony objects from masterColonies.
     * @param {Array<number|string|object>} idsOrObjects
     * @param {string} defaultStatus
     * @returns {Array<object>}
     */
    function getObjectFromIds(idsOrObjects ,defaultStatus = "default") {
      if (!Array.isArray(idsOrObjects) || !Array.isArray(masterColonies)) return [];
      return idsOrObjects
        .map(tagOrId => {
          if (tagOrId && typeof tagOrId === 'object' && 'id' in tagOrId && 'name' in tagOrId) {
            return tagOrId;
          }
          const rawId = typeof tagOrId === 'string' && /^\d+$/.test(tagOrId)
            ? parseInt(tagOrId, 10)
            : tagOrId;
          return masterColonies.find(col => {
            const cid = col.id;
            return (
              (typeof cid === 'number' && cid === rawId) ||
              (typeof cid === 'string' && cid === ('' + rawId))
            );
          });
        })
        .filter(Boolean)
        .map(colony => ({
          ...colony,
          status: defaultStatus
        }));
      }











useEffect(() => {
  if (
    // !hasInitialized.current &&
    // Array.isArray(defaultTags) &&
    // defaultTags.length > 0 &&
    // tagrefColony.current &&
    coloniesReady // ensure masterColonies are loaded
    // Array.isArray(masterColonies) &&
    // masterColonies.length > 0
  ) {
    // console.log("masterColonies:", masterColonies);
    // console.log("defaultTags:", defaultTags);

    const initialTags = getObjectFromIds(selectedTags)

    tagrefColony.current.setTags(initialTags);
    hasInitialized.current = true;
    // console.log("✅ setTags called with:", initialTags);
  }
}, [coloniesReady,masterColonies]);











    const handleSelectTag = (tag) => {
        // console.log("Colonies: Select tag",tag)
        if (onColonySelect) {
            onColonySelect(tag);
        }

    };

    const handleRemoveTag = (tag) => {
        // console.log("Colonies: Remove tag",tag)

        if (onColonyRemove) {
            onColonyRemove(tag);
        }
    };

    const handleChangeTag = (AllTags) => {
        // console.log('Colony ChangeTag',AllTags);
        if (onColonyChangeTag) {
            onColonyChangeTag(AllTags);
        }
    };



    const handleColonyNotFound = (payload) => {
      // payload contains: value, displayKey, parentKey, etc.
      if (onColonyNotFound) {
        onColonyNotFound({
          ...payload,
          source: "colonies"
        });
      }
    };



    // Expose methods using ref
    useImperativeHandle(ref, () => ({
        // getColonyTags: () => tagrefColony.current.getTags(),
        // setColonyTags: (selected) => tagrefColony.current.setTags(selected)
        getObjectFromIds,
        getColonyTags: () => selectedTags,
        setColonyTags: (tags) => setSelectedTags(tags),

    }));
    





    return (
        <div className="containerColonies" style={{ width: '100%', height: 'auto',minWidth :"100%"}}>
            <ComponentTagSelector
                ref={tagrefColony}
                // style={style}

                style={style}        // container style
                tagStyle={tagStyle}  // tags
                inputStyle={inputStyle} // input field

                suggestions={masterColonies}
                // defaultTags={defaultTags}
                maxTags={maxTags}
                selectedTags={selectedTags}
                setSelectedTags={setSelectedTags}



                // if nothing is specified then unlimited, else 1 even if 10 is defined
                displayKey={displayKey} // ✅ FORWARD
                searchKey={searchKey}
                allowFreeAdd={false}
                placeHolder={placeHolder}
              
                parentKey={parentKey}  // ✅ forward parentKey

                onSelectTag={handleSelectTag} // Pass the function correctly
                onRemoveTag={handleRemoveTag}
                onChangeTag={handleChangeTag}
                // onTagNotFound{handleColonyNotFound}
                
                /** 🔥 THIS LINE IS REQUIRED */
                onTagNotFound={handleColonyNotFound}

            />
        </div>

    );
});

export default Comp_Colonies;
